<div class="overlay">
        <div class="overlay-content">
          <kendo-loader type="converging-spinner" size="large"></kendo-loader>
          <p style="color: white;font-size: 20px;" >Loading...</p>
        </div>
</div>